import { render, staticRenderFns } from "./JomBantuList.vue?vue&type=template&id=3dcfa024&"
import script from "./JomBantuList.vue?vue&type=script&lang=js&"
export * from "./JomBantuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports